/**
 * Touch + Click dropdown toggle for menus
 *
 * - Uses pointerup (works for mouse, touch, pen)
 * - Clicking outside .desktop-nav closes all
 * - Nested submenus stay open
 * - Opening one submenu closes its siblings at the same level
 */
const TouchDropdownToggle = {
  _selectors: {
    rootNav: '.desktop-nav',
    triggerItem: '.js-touch-dropdown-toggle'
  },

  onDropdownShow: () => {},
  onDropdownHide: () => {},

  _rootEl: null,

  init(events) {
    if (events?.onDropdownShow) this.onDropdownShow = events.onDropdownShow;
    if (events?.onDropdownHide) this.onDropdownHide = events.onDropdownHide;

    this._rootEl = document.querySelector(this._selectors.rootNav);

    // Bind triggers
    this._rootEl.querySelectorAll(this._selectors.triggerItem).forEach(node => {
      node.addEventListener('pointerup', e => {
        if (e.button !== 0) {
          return;
        }

        e.stopPropagation();
        this.toggleDropdown(e.currentTarget, e);
      });
    });

    // Outside click/tap closes all
    this._rootEl.addEventListener('pointerup', this._onDocumentPointerUp.bind(this));
  },

  toggleDropdown(menuItem, e) {
    const isOpen = menuItem.classList.contains('dropdown-reveal');

    if (isOpen) {
      this.hideDropdown(menuItem, e);
    } else {
      this._closeSiblings(menuItem);
      this.showDropdown(menuItem, e);
    }
  },

  showDropdown(menuItem, e) {
    menuItem.classList.add('dropdown-reveal');
    this.onDropdownShow(e);
  },

  hideDropdown(menuItem, e) {
    menuItem.classList.remove('dropdown-reveal');
    this.onDropdownHide(e);
  },

  hideAll() {
    this._rootEl?.querySelectorAll('.dropdown-reveal')
      .forEach(el => el.classList.remove('dropdown-reveal'));
  },

  _closeSiblings(menuItem) {
    const parent = menuItem.parentElement;
    if (!parent) return;

    parent.querySelectorAll('.dropdown-reveal').forEach(el => {
      if (el !== menuItem) {
        el.classList.remove('dropdown-reveal');
      }
    });
  },

  _onDocumentPointerUp(e) {
    if (!this._rootEl?.contains(e.target)) {
      this.hideAll();
    }
  }
};

export default TouchDropdownToggle;
